<a
  *transloco="let t; read: 'social-share-buttons'"
  id="trkLinkedInShareButton"
  class="btn-share btn-share-linkedin"
  href="javascript:void(0)"
  [attr.aria-label]="t('linkedin_share')"
  (click)="share()">
  <accredible-icon [icon]="'linkedin'"> </accredible-icon>
</a>
